exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".palette {\n\tdisplay: inline-block;\n\tfloat: left;\n\tz-index: 1;\n}\n\n.canvas {\n\tposition:absolute;\n\ttop:20;\n\tleft:15;\n\tz-index: 0;\n\n\n}", ""]);

// exports
